import { AbilityBuilder, Ability } from '@casl/ability'

export const AppAbility = Ability

/**
 * Please define your own Ability rules according to your app requirements.
 * We have just shown Admin and Client rules for demo purpose where
 * admin can manage everything and client can just visit ACL page
 */
const defineRulesFor = user => {
  const { can, rules } = new AbilityBuilder(AppAbility)

  // Base access required for rendering the authenticated app shell
  // Dashboard access is allowed for all authenticated users
  can('read', 'dashboard')

  return rules
}

export const buildAbilityFor = user => {
  return new AppAbility(defineRulesFor(user), {
    // https://casl.js.org/v5/en/guide/subject-type-detection
    // @ts-ignore
    detectSubjectType: object => object.type
  })
}

export const defaultACLObj = {
  action: 'read',
  subject: 'dashboard'
}

export default defineRulesFor
